import { render, staticRenderFns } from "./ipWhitelisting.vue?vue&type=template&id=d28c47c2&"
import script from "./ipWhitelisting.vue?vue&type=script&lang=js&"
export * from "./ipWhitelisting.vue?vue&type=script&lang=js&"
import style0 from "./ipWhitelisting.vue?vue&type=style&index=0&id=d28c47c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports